import {
  Card,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TablePagination,
  TableBody,
  Box,
} from "@material-ui/core";
import React, { FC } from "react";
import { CloneButton, ShowButton, usePermissions } from "react-admin";
import { Raffle } from "../../types/raffle";
import "./index.css";
import { useDispatch } from "react-redux";
import { setMark } from "../../redux/actions/propertyActions";
import LastPageIcon from "@material-ui/icons/LastPage";
import { checkPermission } from "../../helpers/checkPermissions";
interface OldDreamHomeListProps {
  raffles: Array<Raffle> | null;
  handleChangePage: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => void;
  handleChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  handleLastPage: () => Promise<void>;
  rowsPerPage: number;
  total: number;
  page: number;
}

const OldDreamHomeList: FC<OldDreamHomeListProps> = ({
  raffles,
  handleChangePage,
  rowsPerPage,
  handleChangeRowsPerPage,
  handleLastPage,
  total,
  page,
}) => {
  let { permissions } = usePermissions();
  const dispatch = useDispatch();
  const markClone = () => {
    dispatch(setMark());
  };

  return (
    <Card className="active-table-card">
      <TableContainer>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow className="order-row">
              <TableCell id="active-table-head" align="left">
                #
              </TableCell>
              <TableCell id="active-table-head" align="left">
                Title
              </TableCell>
              <TableCell id="active-table-head-actions" align="left">
                Date of Competitions
              </TableCell>
              <TableCell id="active-table-head-actions">Actions</TableCell>
            </TableRow>
          </TableHead>
          {raffles
            ? raffles.map((item: Raffle) => {
                return (
                  <TableBody key={item.id}>
                    <TableRow className="order-row">
                      <TableCell component="th">{item.id}</TableCell>

                      <TableCell>{item.name || item.title}</TableCell>

                      <TableCell>
                        {raffles ? (
                          <div className="actions-table-body">
                            {new Date(item.endsAt).toUTCString()}
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </TableCell>
                      <TableCell>
                        <div className="actions-table-body">
                          {checkPermission(
                            permissions,
                            "Dream home",
                            "Update"
                          ) && (
                            <CloneButton
                              record={item}
                              to={`dreamhome/${item.id}`}
                              onClick={markClone}
                            />
                          )}
                          {checkPermission(
                            permissions,
                            "Dream home",
                            "View"
                          ) && (
                            <ShowButton
                              to={`dreamhome/${item.id}/show`}
                              id="show-dreamhome"
                            />
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                );
              })
            : null}
        </Table>
        <Box
          display="flex"
          alignItems="center"
          paddingRight="1em"
          justifyContent="flex-end"
        >
          <TablePagination
            component="div"
            count={total}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
          <div className="last-page-icon" title="Last Page">
            <LastPageIcon className="last-icon" onClick={handleLastPage} />
          </div>
        </Box>
      </TableContainer>
    </Card>
  );
};

export default OldDreamHomeList;
